/**
 * Computes if an element is fully visible within arbitrarily nested scrollable containers.
 * It only checks vertically for convenience.
 * @param {HTMLElement} element
 */
export function isElementFullyVisible(element: HTMLElement) {
    if (!element) {
        return true;
    }

    const elementRectangle = element.getBoundingClientRect();
    let parent: HTMLElement | null = element.parentElement;

    while (parent) {
        if (isElementVerticallyScrollable(parent)) {
            const parentRect = parent.getBoundingClientRect();

            // Adjust for the parent's scroll position
            const parentVisibleBottom = parentRect.top + parent.clientHeight;

            if (elementRectangle.bottom > parentVisibleBottom) {
                return false;
            }
        }

        // Move up to the next parent
        parent = parent.parentElement;
    }

    return true;
}

function isElementVerticallyScrollable(element: HTMLElement) {
    const style = getComputedStyle(element);

    return (style.overflowY === 'auto' || style.overflowY === 'scroll') && element.scrollHeight > element.clientHeight;
}
